// An upstream saying the CREDENTIAL is not accepted, as opposed to refusing the
// request.
//
// DeepSeek's exact wording is "Authentication Fails, Your api key: ****4WSh is
// invalid". Four characters of a key, and nothing about where that key came
// from — which is the whole problem: the desktop adopts any DEEPSEEK_API_KEY it
// finds in the environment as a BYOK opt-in, so a key set once for something
// else, or long expired, silently replaces the built-in access. One install hit
// exactly that and spent a day believing the product had broken.
//
// Kept in its own module (like session-turn-completion.ts) so the pattern is
// testable without importing a Solid component.
//
// Deliberately narrow: a rate limit, a revoked subscription or an exhausted
// quota each have a different answer, and pointing those at the key switch
// would send people somewhere that changes nothing.
export const UPSTREAM_KEY_REFUSED =
  /(?:Authentication Fails[^]{0,40}?api key:?\s*\**|Incorrect API key provided:?\s*\**)([A-Za-z0-9_-]{2,8})\b[^]{0,40}?(?:is invalid|invalid)/i

/**
 * The last four characters of the key named in such a message, or undefined for
 * anything else.
 *
 * Truncated here rather than trusted from the match: not every upstream masks
 * the value it prints, and rendering eight real leading characters of a live
 * key under a `****` prefix would turn an error card into a partial credential
 * leak — while claiming to be a suffix.
 */
export function refusedKeySuffix(text: string): string | undefined {
  const match = text.match(UPSTREAM_KEY_REFUSED)?.[1]
  return match ? match.slice(-4) : undefined
}
